import makeStyles from '@material-ui/styles/makeStyles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AdvancedChecklistStateType } from './state/AdvancedChecklist';
export interface IAdvancedChecklistFooter {
    onCancel: () => void;
    onSubmit: () => void;
    mandatorySelection?: boolean;
    state: AdvancedChecklistStateType;
    getSelected: () => any[];
    submitButtonText?: string;
    cancelButtonText?: string;
    isDisabled?: boolean
}

const useStyles = makeStyles({
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '1.25rem 3.5rem',
        boxShadow: '0px 0px 20px rgba(33, 33, 33, 0.1)',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        zIndex: 999,
    },
    CancelButton: {
        background: '#F3F4F9',
        borderRadius: '8px',
        width: 'fit-content',
        color: '#212121',
        fontSize: '0.9375rem',
        padding: '0.875rem 1.5625rem',
        margin: '0 1rem',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    SubmitButton: {
        background: '#FFDD02',
        borderRadius: '8px',
        width: 'fit-content',
        color: '#212121',
        fontSize: '0.9375rem',
        fontWeight: 600,
        padding: '0.875rem 1.5625rem',
        margin: '0 1rem',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    SubmitButtonDisabled: {
        background: 'rgba(0, 0, 0, 0.12)',
        color: 'rgba(0, 0, 0, 0.26)',
        fontWeight: 600,
    },
});
function AdvancedChecklistFooter(props: IAdvancedChecklistFooter) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(props?.isDisabled || false);
    useEffect(() => {
        if (props.mandatorySelection && props.getSelected().length < 1) {
            setSubmitDisabled(true);
        } else {
            setSubmitDisabled(false);
        }

        if (props.isDisabled) {
            setSubmitDisabled(props.isDisabled)
        }
        // eslint-disable-next-line
    }, [props.mandatorySelection, props.state.listItems,props.isDisabled]);

    return (
        <div
            style={{
                height: '100%',
                width: '100%',
            }}
        >
            <div className={classes.footer}>
                <div className={classes.CancelButton} onClick={props.onCancel}>
                    {props.cancelButtonText ?? t('manageMenu.buttons.cancel')}
                </div>
                <div
                    className={`${classes.SubmitButton} ${submitDisabled ? classes.SubmitButtonDisabled : ''}`}
                    onClick={() => {
                        if (!submitDisabled) {
                            props.onSubmit();
                        }
                    }}
                >
                    {props.submitButtonText ?? t('forms.buttons.submitupdates')}
                </div>
            </div>
        </div>
    );
}

export default AdvancedChecklistFooter;
